//Определяет параметры соединения с odoo для использования XML-RPC
import Simbix from './simbix-promise'
import { SimbixConnectActions } from '../actions'

export const getSimbixProvider =() =>{
	//console.log("getSimbixProvider")
	const node = document.getElementById('simbixConnect')
	if (!node){
		alert("Параметры соединения c базой данных семантики отсутствуют!\nОбратитесь к администратору системы.")
		throw new Error("Параметры соединения c базой данных семантики отсутствуют!");
	}
	//console.log(node);
	const host = node.getAttribute("host");
	const port = node.getAttribute("port");
	if ((host==null)||(port==null)){
		alert("Часть параметров соединения c базой данных семантики отсутствуют!\nОбратитесь к администратору системы.")
		throw new Error("Часть параметров соединения c базой данных семантики отсутствуют!", host, port);
	}
	const username = node.getAttribute("username");
	const password = node.getAttribute("password");
	//Если параметра нет, то возвращает null
	const session_id = node.getAttribute("session_id");
	if (session_id==null){
		if ((username==null)||(password==null)){
//			alert("Часть параметров авторизации c базой данных семантики отсутствуют!\nОбратитесь к администратору системы.")
//			throw new Error("Часть параметров соединения c базой данных семантики отсутствуют!", username, password, session_id);
		}
	}
	return new Simbix({host, port, username, password, session_id})
}

//Провести соединения с БД и загрузить описание внешних приложений
//В currentUser - информация о текущем пользователе, полученного после авторизации, например
// accessToken: {expired: "2019-01-26T06:21:37.031Z", value: "ebabfd40-07c7-38b9-b9f3-9b786f4e097c"}
// fullName: "С. А. Карпенко"
// id: 57006
// userName: "karpenko_sa"
export function connectSimbix(currentUser) {
    return SimbixConnectActions.authenticate(currentUser)
}
